<template>
    <div class="maintenance-page">
        <p class="picto">☕️</p>
        <h1 class="title">Nous revenons bientôt...</h1>
        <div class="main">
        Notre plateforme de billetterie est actuellement en maintenance pour améliorer nos services.
        Nous faisons le nécessaire pour rétablir l’accès rapidement. <br>
        Merci de votre compréhension.
        <span>L’équipe <a href="https://www.oandb.fr" target="blank">OandB</a>.</span>
        </div>
    </div>
</template>
<style>
    .maintenance-page {
        padding: 50px 20px;
        width: 100%;
        max-width: 750px;
        text-align: center;
        margin: 0 auto;
        color: #ddd;
        border-radius: 10px;
    }
    .maintenance-page .picto {
        font-size: 68px;
        margin-bottom: 20px;
    }
    .maintenance-page .title {
        font-weight: bold;
        font-size: 52px;
        line-height: 72px;
        margin-bottom: 10px;
    }
    .maintenance-page .main {
        font-size: 18px;
        line-height: 28px;
    }
    .maintenance-page .main span {
        font-size: 16px;
        line-height: 22px;
        margin-top: 20px;
        font-weight: normal;
        display: block;
        text-align: right;
    }
    .maintenance-page .main a {
        color: #ddd;
        text-decoration: underline;
    }
</style>